import "core-js/modules/es.function.name.js";
import { stringifyHelper } from './stringifyHelper';
export var getErrorJsonData = function getErrorJsonData(rawError) {
  if (rawError instanceof Error) {
    var name = rawError.name,
        message = rawError.message,
        stack = rawError.stack;
    return {
      name: name,
      message: message,
      stack: stack
    }; // If raw error is an error instance, extract name, message and stack directly as JSON.stringify will return {} for Error instance
  } else {
    return {
      name: 'Unknown error',
      message: stringifyHelper(rawError)
    };
  }
};
//# sourceMappingURL=getErrorJsonData.js.map